'use client';

import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Cell,
} from 'recharts';
import { ALL_MATCHES, ALL_PROPERTIES } from '@/lib/data/sharedData';

// Build matches by zone from shared data
const ZONE_COLORS = ['#0F4C81', '#1a6fb5', '#2d8fd4', '#E8A020', '#3baed4', '#64b5c8', '#94c9d4'];
const zoneCount: Record<string, number> = {};
ALL_MATCHES.forEach(m => {
  const prop = ALL_PROPERTIES.find(p => p.ref === m.localRef);
  const zone = prop?.quartier || m.localVille;
  zoneCount[zone] = (zoneCount[zone] || 0) + 1;
});
const data = Object.entries(zoneCount)
  .sort((a, b) => b[1] - a[1])
  .slice(0, 7)
  .map(([zone, matchs], i) => ({ zone, matchs, color: ZONE_COLORS[i] || '#94c9d4' }));

const totalMatchs = ALL_MATCHES.length;

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-slate-200 rounded-xl shadow-modal p-3">
        <p className="text-xs font-600 text-slate-500 mb-1">{label}</p>
        <p className="text-sm font-700 text-slate-900">
          {payload[0].value} <span className="text-xs font-500 text-slate-500">matchs</span>
        </p>
      </div>
    );
  }
  return null;
};

export default function MatchesByZoneChart() {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-card h-full">
      <div className="mb-5">
        <h3 className="text-base font-600 text-slate-900">Matchs par zone</h3>
        <p className="text-xs text-slate-400 mt-0.5">Zones les plus actives ce mois</p>
      </div>

      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 16, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" horizontal={false} />
          <XAxis
            type="number"
            tick={{ fontSize: 11, fill: '#94a3b8', fontFamily: 'DM Sans' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            type="category"
            dataKey="zone"
            tick={{ fontSize: 11, fill: '#475569', fontFamily: 'DM Sans' }}
            axisLine={false}
            tickLine={false}
            width={70}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: '#f8fafc' }} />
          <Bar dataKey="matchs" radius={[0, 4, 4, 0]} maxBarSize={18}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <div className="mt-4 pt-4 border-t border-slate-100">
        <p className="text-xs text-slate-500">
          <span className="font-600 text-slate-700">{totalMatchs}</span> matchs actifs au total —{' '}
          <span className="text-green-600 font-600">{ALL_MATCHES.filter(m => m.scoreGlobal >= 80).length} score ≥ 80%</span>
        </p>
      </div>
    </div>
  );
}